import { get, post, put } from './http-calls';

export const updateOperator = async (data) => {
    let res = await post(`OperatorDetails/OperatorDetails`, data, { useAuthToken: true });
    return res;
};